import React, { useState } from "react";

import theme, {
  roundness,
  navbarHeight,
  styles as commonStyles,
} from "../../../utils/styles";

import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";

import data from "../../../data/partners";

const Partners = (props) => {
  const { yOffset, sectionIndex, isBreakpoint } = props;
  const documentHeight = window.innerHeight * sectionIndex;
  let scrolledInPercentage = Math.floor((yOffset / documentHeight) * 100);

  const [hover, setHover] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);

  const renderItems = data.map((item, index) => {
    let highlight = index === hoverIndex;
    return (
      <div
        key={index}
        style={styles(isBreakpoint).card(hover, highlight)}
        onClick={(e) => window.open(item.link, "_blank")}
      >
        <div
          onMouseEnter={(e) => {
            setHover(true);
            setHoverIndex(index);
          }}
          onMouseLeave={(e) => {
            setHover(false);
            setHoverIndex(index);
          }}
          style={styles(isBreakpoint).cardContent}
        >
          <img
            src={item.image}
            alt={item.title}
            style={styles(isBreakpoint).image}
          />
          <div style={styles(isBreakpoint).title}>{item.title}</div>
        </div>
        {hover && highlight ? (
          isBreakpoint ? null : (
            <div style={styles(isBreakpoint).tooltip}>{item.link}</div>
          )
        ) : null}
      </div>
    );
  });

  return (
    <div style={styles(isBreakpoint).root} id="#partners">
      <Fade when={scrolledInPercentage > 70} bottom>
        <div style={commonStyles.sectionHeading}>Our Partners</div>
      </Fade>
      <Slide when={scrolledInPercentage > 70} left>
        <div style={styles(isBreakpoint).container}>{renderItems}</div>
      </Slide>
    </div>
  );
};

export default Partners;

const styles = (isBreakpoint) => {
  let cardWidth = 250;
  let cardHeight = 200;
  let cardContentSpacing = 30;
  let fontSize = 12;
  let rowGap = navbarHeight / 3;
  let columnGap = navbarHeight / 3;

  if (isBreakpoint) {
    cardWidth /= 2;
    cardHeight /= 2;
    cardContentSpacing /= 2;
    fontSize /= 2;
    columnGap /= 2;
    rowGap /= 2;
  }

  return {
    root: {
      height: "100vh",
      background: theme.colors.background,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
    },
    container: {
      height: "50%",
      borderStyle: "solid none",
      borderColor: "#ffffff00",
      borderWidth: navbarHeight / 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      rowGap,
      columnGap,
    },

    card: (hover, highlight) => ({
      position: "relative",
      width: cardWidth,
      height: cardHeight,
      padding: hover && highlight ? 16 : 8,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "white",
      borderRadius: roundness.card,
      transition: "ease-in-out 0.3s",
      opacity: hover && !highlight ? 0.5 : 1,
      cursor: "pointer",
    }),
    tooltip: {
      position: "absolute",
      bottom: -40,
      color: theme.colors.background,
      background: "white",
      padding: 8,
      borderRadius: roundness.card,
      fontSize: 12,
    },
    cardContent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
      rowGap: cardContentSpacing,
    },
    image: {
      height: cardHeight / 2,
    },
    title: {
      fontSize: fontSize,
      fontWeight: "bold",
      width: cardWidth / 2,
      textAlign: "center",
      color: theme.colors.background,
    },
  };
};
